<template>
    <div>
        <div v-if="!isMobile" class="navbar-fixed">
            <header class="platform-header">
                <nav class="menu-buttons">
                    <div class="container nav-wrapper hide-on-med-and-down">
                        <div class="brand-logo">
                            <a @click="getLandingPage('_blank')" target="_blank">
                                <img :src="env + '/landing/condotechs/engelink.svg'" alt="" />
                            </a>
                            <a @click="getLandingPage('_blank')" target="_blank">
                                <img :src="env + '/landing/condotechs/condotechs.svg'" alt="" />
                            </a>
                        </div>

                        <ul id="nav-mobile" class="right">
                            <li>
                                <a class="btn-default btn-dark-blue" @click="getLandingPage">Encontre fornecedores</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        </div>

        <div v-else :class="[{ 'opacity-background': show }]">
            <header>
                <div class="navbar-fixed">
                    <nav class="header-condotechs-mobile">
                        <div
                            @click="
                                show = !show;
                                $emit('show', show);
                            "
                            :class="['nav-icon', { open: show }]"
                        >
                            <div></div>
                        </div>
                        <div style="margin-left: 20px;" class="brand-logo">
                            <a target="_blank">
                                <img :src="env + '/landing/condotechs/engelink.svg'" alt="" />
                            </a>
                            <a target="_blank">
                                <img :src="env + '/landing/condotechs/condotechs.svg'" alt="" />
                            </a>
                        </div>
                    </nav>
                </div>
                <div :class="['side-bar-mobile condotechs-mobile-menu', { show: show }]">
                    <ul>
                        <li>
                            <a class="btn-default btn-dark-blue" @click="getLandingPage">Encontre fornecedores</a>
                        </li>
                    </ul>
                </div>
            </header>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CondotechHeader',
    data: () => ({
        env: process.env.VUE_APP_STATIC_BASE_URL,
        show: false,
        isMobile: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    methods: {
        getLandingPage(target = false) {
            this.$emit('show', false);
            if (target) {
                const routeData = this.$router.resolve({ name: 'LandingPage' });
                window.open(routeData.href, target);
            } else {
                this.$router.push({ name: 'LandingPage' });
            }
        },
    }
};
</script>

<style>
.platform-header .menu-buttons {
    background-color: #f5f5f5;
}
nav .brand-logo {
    display: flex !important;
    align-items: flex-start;
    flex-direction: row;
}

nav .brand-logo img {
    margin-top: 8px;
}

.menu-buttons ul li:not(:last-child) {
    margin-right: 5px;
}

.btn-default {
    background-color: transparent;
    color: #383838;
    border: none;
    text-align: center;
    font-size: 16px;
    line-height: 19px;
}
.btn-default.btn-dark-blue {
    background-color: #003f7e;
    color: #fff;
    font-weight: 700;
}

.btn-default {
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 7px 10px;
    display: initial;
    transition: all ease 0.3s;
}
nav .button-collapse {
    height: 54px;
    line-height: 54px;
}
side-nav .btn-default {
    color: #fff;
    display: block;
    margin: 10px 0;
}
/* Menu Mobile */
li {
    list-style-type: none;
}
.condotechs-mobile-menu {
    background-color: #f5f5f5 !important;
}
.header-condotechs-mobile {
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    z-index: 999 !important;
}
nav .brand-logo-condotechs-mobile {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    height: 54px;
    justify-content: center;
    width: 150px;
}
nav .brand-logo-condotechs-mobile img {
    max-height: 40px;
    max-width: 150px;
}
/* // Tracinho de cima */
.nav-icon:before {
    width: 35px;
}
/* // Tracinho do meio */
.nav-icon {
    /* // margin: 1em; */
    left: 0;
    position: fixed;
    width: 30px;
    margin-left: 25px;
    align-self: center;
}
/* // Tracinho de baixo */
.nav-icon:after {
    width: 25px;
}
.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #003f7e;
    border-radius: 3px;
    content: '';
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
/* // largura quando o menu está aberto */
.nav-icon.open:after,
.nav-icon.open:before,
.nav-icon.open {
    width: 20px !important;
    padding-left: 0px !important;
}
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
.side-bar-condotechs-mobile {
    box-shadow: inset 0 0 2px black;
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 0%;
    z-index: 9999 !important;
    background-color: #f5f5f5;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    box-shadow: black;
}
.side-bar-condotechs-mobile.show {
    width: 70%;
}
.side-bar-condotechs-mobile ul {
    /* // position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
}
.side-bar-condotechs-mobile ul li {
    position: relative;
    width: 100%;
    list-style: none;
}
.side-bar-condotechs-mobile ul li a .title-mobile {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}
.side-bar-condotechs-mobile ul li a {
    position: relative;
    display: block;
    width: 100%;
    /* // display: flex; */
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 16px;
    color: #707070;
}
.side-bar-condotechs-mobile.show {
    width: 70%;
}
/* efeito de opacidade do menu de fornecedor na versão mobile */
.opacity-background {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    display: table;
    transition: 0.5s;
    overflow: hidden;
}
@media screen and (max-width: 1366px) {
    .btn-default {
        padding: 7px 10px;
    }
}
@media screen and (max-width: 992px) {
    .btn-default.btn-dark-blue {
        width: 90%;
        margin: 0 auto;
    }
    nav .brand-logo img {
        margin-top: 12px;
        max-height: 30px;
        max-width: 150px;
    }
    .side-nav {
        background: #f5f5f5;
        background: linear-gradient(to bottom, #f5f5f5, #f5f5f5);
    }
    .side-nav .btn-default {
        color: #383838;
    }
    nav .button-collapse {
        color: #003f7e !important;
    }
}
</style>
